//------------------------------------------------------ funciones
import {
  subscribeTable,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";
import { cacheStore } from "../cache";
import { realtime } from "../store";
import { limpiarFecha } from "../../functions/dataFunctions";

const TABLA = "asignaciones";

// -------------------------------------------------- realtime

export const subscribeAsignaciones = (callback) => {
  return subscribeTable(TABLA, (rows) => {
    const personasMap = Object.fromEntries(
      (realtime.personas || []).map((ps) => [String(ps.id), ps]),
    );

    const stockMap = cacheStore.stock?.map || {};

    const asignaciones = rows
      .map((as) => {
        const persona = personasMap[String(as.persona)];
        const articulo = stockMap[String(as.articulo)];

        return {
          ...as,
          nombrePersona: persona?.nombreCompleto || "",
          nombreArticulo: articulo?.descripcion || "",
          unidadArticulo: articulo?.unidad || "",
          cantidadFull: `${as.cantidad} (${articulo?.unidad || ""})`,
        };
      })
      .sort((a, b) => limpiarFecha(b.fecha) - limpiarFecha(a.fecha));

    callback(asignaciones);
  });
};

// -------------------------------------------------- metodos

export const createAsignacion = ({ id, ...data }) =>
  createRow(TABLA, id, data);

export const updateAsignacion = (id, data) => updateRow(TABLA, id, data);

export const deleteAsignacion = (id) => deleteRow(TABLA, id);
